(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-columns"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.feature_columns_slider').slick({
      dots: true,
      arrows: false,
      slidesToShow: 1,
      mobileFirst: true,
      adaptiveHeight: true,
      fade: true,
      cssEase: 'linear'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $(function() {
    $('#footer-optin').submit(function(e) {
      e.preventDefault();
      var $optin = $('#sitefooteroptin');
      var $optinImg = $('#ebook-offer-img');
      var $emailInput = $('#siteoptinemail');
      var $successMsg = $('#successmsg');
      var $loadingIndicator = $('#sitefooteroptin__loading');

      $optin.hide();
      $optinImg.hide();
      $loadingIndicator.show();
      $loadingIndicator[0].scrollIntoView();

      window.bt.sendLead(
        $emailInput.val(),
        {
          optInName: 'storefrontfooter',
          contactTags: ['shopify_lead','website_footer_signup_v2']
        }
      ).then(function(transaction_id) {
        $loadingIndicator.hide();

        window[window.bt.settings.trackersDataLayer].push(function(trackers) {
          trackers.action(
                'lead', 'opt-in', 'Opt-in',
                {
                  name: 'Opt-in Footer',
                  label: location.pathname,
                  // eslint-disable-next-line camelcase
                  success: true,
                  email: $emailInput.val()
                }
              );
        });

        if (transaction_id !== false) {
          $successMsg.show();
          $successMsg[0].scrollIntoView();
          console.log(transaction_id);
        } else {
          console.error('Failed to submit footer opt-in.');
          window.alert("Oops! Something didn't go right.");
          $optin.show();
          $optinImg.show();
        }
      }).catch(function(err) {
          console.log(err);
          $loadingIndicator.hide();
          $optin.show();
          $optinImg.show();
      });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    var settingsId = 'slideshow-{{ section.id }}';
    $('.slideshow-wrapper').slick({
      dots: true,
      arrows: false,
      slidesToShow: 1,
      fade: true,
      cssEase: 'linear',
      autoplay: window.sectionSettings[settingsId].autoplay,
      autoplaySpeed: window.sectionSettings[settingsId].autoplaySpeed,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
